import Splide from '@splidejs/splide';
import './news-tabs';
import './video-modal';
import 'atropos/css';
import Atropos from 'atropos';
import ScrollReveal from 'scrollreveal';

document.addEventListener('DOMContentLoaded', function() {
    const atroposEls = document.querySelectorAll('[data-atropos]');
    atroposEls.forEach((el) => {
        if (el._atroposInstance) return;
        const instance = Atropos({
            el,
            activeOffset: 30,
            shadow: false,
            highlight: false,
            rotateTouch: false,
            duration: 300,
            eventsListeners: {
                pointerEnter: null,
                pointerMove: null,
                pointerLeave: null,
            },
            touch: false,
        });
        el._atroposInstance = instance;
    });

    const partitionCards = document.querySelectorAll('.partition-card');
    partitionCards.forEach(card => {
        card.addEventListener('click', (e) => {
            const link = card.closest('a');
            if (link && link.href) {
                window.location.href = link.href;
            }
        });
    });

    const isRTL = document.documentElement.dir === 'rtl' || document.documentElement.lang === 'ar';
    const slideshowElement = document.querySelector('#slideshow');
    if (slideshowElement) {
        new Splide( '#slideshow', {
        type: 'loop',
        perPage: 1,
        autoplay: {
            delay: 6000,
            disableOnInteraction: false,
        },
        interval: 5000,
        pauseOnHover: true,
        arrows: false,
        pagination: true,
        drag: true,
        direction: isRTL ? 'rtl' : 'ltr',
        i18n: {
            prev: 'Previous slide',
            next: 'Next slide',
            first: 'Go to first slide',
            last: 'Go to last slide',
            slideX: 'Go to slide %s',
            pageX: 'Go to page %s',
            play: 'Start autoplay',
            pause: 'Pause autoplay',
        },
        classes: {
            slide: 'splide__slide',
            list: 'splide__list',
        },
        aria: {
            slide: 'slide',
            slideLabel: 'Slide %d of %d',
        }
    } ).mount();
    }

    const sr = ScrollReveal({
        distance: '40px',
        duration: 700,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
        mobile: true,
        desktop: true,
        reset: false,
        viewFactor: 0.12,
        cleanup: true,
    });

    function initScrollReveal() {
        try {
            sr.reveal('#sections-title', { origin: 'top' });
            sr.reveal('#publications-title', { origin: 'bottom' });
            sr.reveal('#news-tabs', { origin: 'top' });
            sr.reveal('#accreditation-content h2', { origin: 'left' });
            sr.reveal('#video-thumbnail', { origin: 'right' });
        } catch (e) { /* noop */ }

        try {
            sr.reveal('#section-cards-1 .partition-card', { interval: 120, origin: 'bottom', viewFactor: 0.1 });
            sr.reveal('#section-cards-2 .partition-card', { interval: 120, origin: 'bottom', viewFactor: 0.1 });
            sr.reveal('#sections-image', { origin: 'right', duration: 900, distance: '60px' });
        } catch (e) { /* noop */ }

        try {
            sr.reveal('.publication-card', { interval: 150, origin: 'bottom', viewFactor: 0.15 });
            sr.reveal('.counter-card-item', { interval: 180, scale: 0.98, viewFactor: 0.1 });
        } catch (e) { /* noop */ }
    }

    if (document.getElementById('loading-screen')) {
        window.addEventListener('loading-screen-hidden', initScrollReveal);
    } else {
        initScrollReveal();
    }
});
